import React from 'react';

import { ErrorMessage } from '@eika/attention-message';
import { ButtonTypes } from '@eika/button';
import { ButtonWithSpinner } from '@eika/button-with-spinner';
import { CheckmarkAnimation } from '@eika/checkmark-animation';
import { IconTypes } from '@eika/icon';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import piwik from '@/piwik/piwik';
import { useActivateCard } from '@/react-query/hooks/mutation/use-activate-card';

import { Card } from '@generated-types';
import useText from '@hooks/use-text';

interface ActivateCardProps {
    card: Card;
}

const ErrorDisplay = () => {
    const { messageErrorText } = useText();

    return (
        <div
            className="activate-error-display"
            data-track-id={piwik.activateCardForm.activateCardFailure.dataTrackId}
            data-track-linkname={piwik.activateCardForm.activateCardFailure.dataTrackLinkname}
            id={piwik.activateCardForm.activateCardFailure.dataTrackId}
        >
            <ErrorMessage text={messageErrorText} icon={IconTypes.LUKK_24} />
        </div>
    );
};

const ActivateCard = ({ card }: ActivateCardProps) => {
    const { activateInfoBox2, activateButton, messageSuccessactivateCard, genericTryAgain, activateTitle } = useText();
    const {
        isPending: isActivatingCard,
        isError: failedActivatingCard,
        isSuccess,
        mutate: onActivateCard,
    } = useActivateCard(card.type, card.id);
    const handleActivateCardClick = () => {
        onActivateCard();
    };

    if (isSuccess) {
        return (
            <div
                className="success-container"
                data-track-id={piwik.activateCardForm.activateCardSuccess.dataTrackId}
                data-track-linkname={piwik.activateCardForm.activateCardSuccess.dataTrackLinkname}
                id={piwik.activateCardForm.activateCardSuccess.dataTrackId}
            >
                <div>
                    <CheckmarkAnimation />
                </div>
                <p>{messageSuccessactivateCard}</p>
            </div>
        );
    }

    return (
        <div className="activate-card-display">
            <div className="customer-card-activate">
                <RichIcon type={RichIconTypes.DIGITALTKORT_ABONNEMENT} />
            </div>
            <h3 className="question">{activateTitle}</h3>
            <p>{activateInfoBox2}</p>
            {failedActivatingCard && <ErrorDisplay />}
            <ButtonWithSpinner
                buttonType={ButtonTypes.STANDARD_POSITIVE}
                data-track-id={piwik.activateCardForm.activateCard.dataTrackId}
                data-track-linkname={piwik.activateCardForm.activateCard.dataTrackLinkname}
                id={piwik.activateCardForm.activateCard.dataTrackId}
                onClick={handleActivateCardClick}
                showSpinner={isActivatingCard}
            >
                {failedActivatingCard ? genericTryAgain : activateButton}
            </ButtonWithSpinner>
        </div>
    );
};

export default ActivateCard;
